var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container bj-label-colon" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "300px" },
        },
        [
          _c(
            "BjDivider",
            { attrs: { "right-fixed": "" } },
            [
              _vm._v(
                _vm._s(_vm.$t("StockVerifyConfigutration.strategy")) + " "
              ),
              _c(
                "template",
                { slot: "right" },
                [
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v(_vm._s(_vm.$t("cancelText"))),
                  ]),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName:
                            "v-permission:SettingStockAuditStrategy_Save",
                          arg: "SettingStockAuditStrategy_Save",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.resetForm("form")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("resetText")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName:
                            "v-permission:SettingStockAuditStrategy_Save",
                          arg: "SettingStockAuditStrategy_Save",
                        },
                      ],
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.handleConfirm("form")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("saveText")))]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("StockVerifyConfigutration.audit"),
                prop: "allotAudit",
              },
            },
            [
              _c("el-switch", {
                model: {
                  value: _vm.form.allotAudit,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "allotAudit", $$v)
                  },
                  expression: "form.allotAudit",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("StockVerifyConfigutration.virtual"),
                prop: "transferAudit",
              },
            },
            [
              _c("el-switch", {
                model: {
                  value: _vm.form.transferAudit,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "transferAudit", $$v)
                  },
                  expression: "form.transferAudit",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("StockVerifyConfigutration.approval"),
                prop: "stockReservedAudit",
              },
            },
            [
              _c("el-switch", {
                model: {
                  value: _vm.form.stockReservedAudit,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "stockReservedAudit", $$v)
                  },
                  expression: "form.stockReservedAudit",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("StockVerifyConfigutration.review"),
                prop: "branchWarehouseAudit",
              },
            },
            [
              _c("el-switch", {
                model: {
                  value: _vm.form.branchWarehouseAudit,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "branchWarehouseAudit", $$v)
                  },
                  expression: "form.branchWarehouseAudit",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }